module.exports = __webpack_public_path__ + "06_mole.380362fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/06_mole.png
// module id = lYhg
// module chunks = 0